export default "__VITE_ASSET__B1ITqA_N__"